import { Injectable } from '@angular/core';

import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportCustomerProductService extends TmsWebBaseImportService {
  constructor() {
    super('ImportCustomerProduct', 'Customer Products');
  }
}
